/**
 * The simplified landing's help, as an icon in each surface's header (owner 2026-10-31: "move help as an icon in the
 * header"). It opens the same `PAGE_HELP['simple-landing']` markdown in a `HelpPanel` that the rail footer used to open;
 * the landing has no `PageHeader`, so this button is how its page help is reached. Demo page: /chats (header icon
 * actions).
 */
import { HelpCircle } from 'lucide-react';
import React, { useState } from 'react';
import { Button } from '../../components/ui/Button.js';
import { HelpPanel } from '../../components/ui/HelpPanel.js';
import { PAGE_HELP } from '../../help/index.js';

export const SimpleHelpButton: React.FC = () => {
  const [open, setOpen] = useState(false);
  const help = PAGE_HELP['simple-landing'];
  return (
    <>
      <Button variant="ghost" size="sm" iconOnly aria-label="Help" onClick={() => setOpen(true)}>
        <HelpCircle size={16} aria-hidden />
      </Button>
      <HelpPanel
        open={open}
        onClose={() => setOpen(false)}
        title={help?.title ?? 'Simplified landing'}
        markdown={help?.markdown ?? ''}
      />
    </>
  );
};
